/*
 *
 * ListPointOfSales
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 14-May-2025
*/

import ListPointOfSales from './ListPointOfSales'

export default ListPointOfSales
